
import { Monitor, Globe, Shield } from 'lucide-react';
import ServiceCard from './ServiceCard';

interface ServicesGridProps {
  onGetFreeAccess: () => void;
}

const ServicesGrid = ({ onGetFreeAccess }: ServicesGridProps) => {
  const services = [
    {
      icon: Monitor,
      flag: "🇺🇸",
      title: "Residential US Remote Desktop",
      features: [
        "Fast US-based desktops",
        "Always-on access",
        "Perfect for freelancers & automation"
      ],
      color: "green" as const
    },
    {
      icon: Globe,
      flag: "🇺🇸",
      title: "Residential US Proxies",
      features: [
        "Clean IPs",
        "Low block rates",
        "Ideal for scraping & SEO"
      ],
      color: "blue" as const
    },
    {
      icon: Shield,
      flag: "🇺🇸",
      title: "Residential US VPN",
      features: [
        "100% Residential IPs",
        "No logs, no throttling",
        "Bypass geo-blocks & stay anonymous"
      ],
      color: "purple" as const
    }
  ];

  return (
    <div className="grid md:grid-cols-3 gap-6 mb-6 flex-grow">
      {services.map((service, index) => (
        <ServiceCard
          key={index}
          icon={service.icon}
          flag={service.flag}
          title={service.title}
          features={service.features}
          color={service.color}
          onGetFreeAccess={onGetFreeAccess}
        />
      ))}
    </div>
  );
};

export default ServicesGrid;
